import React from 'react'
import { Flex } from '@stars-ecom/shared-atoms-ui'
import './review.css'

const Reviews = (props) => {
  const { product } = props;

  return (
    <Flex
      w="100%"
      bg="#f3f4f9"
      justifyContent="space-around"
      className="review_tab"
    >
      <div className="skeepers_product__reviews"
        data-product-id={
          [
            product?.customFields?.productGroupCode,
            product?.customFields?.externalCode
          ].filter(f => f).join(',')
        }
        data-locale="fr_FR"
      >
      </div>
      
    </Flex>
  )
}

export { Reviews }